import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import OurTeamOne from '../../components/inner-components/OurTeamOne';
import TestimonialTwo from '../../components/section-components/TestimonialTwo';
import Quote from '../../components/section-components/Quote';
import FooterOne from '../../common/footer/FooterOne';

const OurTeam = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Our Team"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Our Team"
        />
        
        <OurTeamOne />
        
        <TestimonialTwo />
        
        <Quote />
                
        <FooterOne />
        </>
    )
}
    
export default OurTeam;